// @flow
import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { Strong } from '@finect/tabular-core/Strong';

export const Head = styled.div`
  display: flex;
  width: 100%;
`;

export const HeadInner = styled.div`
  display: flex;
  align-items: center;
  flex-flow: row-reverse;
  flex-shrink: 1;
  justify-content: center;
  width: 100%;

  ${minMediaQueries.phablet`
    width: 50%;
    margin-top: 0;
    flex-flow: row;
  `};
`;

export const ItemHeadTitle = styled.div`
  display: flex;
  justify-content: center;
  width: 50%;
  margin: 15px;
  text-align: center;
  ${getFont(0)}

  ${minMediaQueries.phablet`
    justify-content: flex-start;
    width: 50%;
    margin: 15px;
  `};

  svg {
    flex-shrink: 0;
  }
`;

export const ItemHeadDate = styled.div`
  display: none;
  width: 50%;
  margin: 15px 10px;
  text-align: center;

  ${minMediaQueries.phablet`
    display:block;
    width: 50%;
  `};
`;

export const ItemHeadAdviserDisplayName = styled(Strong)`
  align-self: center;
  margin-left: 16px;
  line-height: 20px;
  text-align: left;
`;

export const ItemHeadStatus = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  width: 80%;
  margin: 10px 15px 5px 0;
  color: ${({ theme }) => theme.colors.terciaryM};
  text-align: center;
  ${getFont('-2', 'compact')}
  ${minMediaQueries.phablet`
    align-items: center;
    width: 90%;
    margin: 0;
    flex-flow: nowrap;
  `};
`;

export const ItemHeadMenuAction = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-right: 16px;
  color: ${({ theme }) => theme.colors.primary};
  text-align: center;

  > * {
    display: none;
  }

  ${minMediaQueries.phablet`
    > * {
      display: block;
    }
    width: 10%;
  `};
`;

export const ToggleButton = styled.button`
  display: none;
  color: ${({ theme }) => theme.colors.primaryM};

  ${minMediaQueries.phablet`
    display: block;
    width: 100%;
    text-align: center;
    margin-right: 0 auto;
  `};
`;

// Esto es una guarrindongada
export const Status = styled.span`
  height: 24px;
  padding: 2px 8px;
  border: 1px solid;
  border-radius: ${({ theme }) => theme.borderRadius};
  border-color: ${({ status }) =>
    (status === 'Unsold'
      ? ({ theme }) => theme.colors.accent2
      : status === 'Completed'
        ? ({ theme }) => theme.colors.chart4
        : ({ theme }) => theme.colors.primary)};
  margin: 5px 0;
  color: ${({ status }) =>
    (status === 'Unsold'
      ? ({ theme }) => theme.colors.accent2
      : status === 'Completed'
        ? ({ theme }) => theme.colors.chart4
        : ({ theme }) => theme.colors.primary)};

  ${getFont('-2')}
  ${minMediaQueries.phablet`
  margin: 0 10px;
  `};
`;

export const Link = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primaryD};
  ${getFont('-1')}

  > svg {
    margin-right: 5px;
  }
`;
